import { create } from 'zustand'

import { browserStore } from '@/utils/browser-store'

export type Theme = 'light' | 'dark'

/**
 * The viewer's own choice, or nothing while the operating system decides.
 *
 * The key and the shape are also read by the inline script in `index.html`,
 * which applies the choice before the stylesheet paints — a theme applied from
 * the bundle shows the other one for as long as the bundle takes to parse.
 */
const stored = browserStore<Theme>('brickup:theme', {
  validate: value => value === 'light' || value === 'dark',
})

type ThemeState = {
  /** `null` while the app follows the operating system. */
  choice: Theme | null
  setTheme: (theme: Theme) => void
}

export const useThemeStore = create<ThemeState>()(set => ({
  choice: stored.load(),
  setTheme: theme => {
    stored.save(theme)
    // `data-theme` sets `color-scheme`, and every colour token is a
    // `light-dark()` pair that resolves against it — writing the attribute is
    // the whole mechanism.
    document.documentElement.dataset.theme = theme
    set({ choice: theme })
  },
}))
